// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {PutTouroperatorVoucherSuccess} from 'redux/v1/touroperatorVoucher/actions';
import type {TouroperatorVoucherState} from 'redux/v1/touroperatorVoucher/TouroperatorVoucherState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  PURE,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {
  PUT_TOUROPERATOR_VOUCHER,
  RESET_TOUROPERATOR_VOUCHER,
} from 'redux/v1/touroperatorVoucher/actions';
import {touroperatorVoucherState} from 'redux/v1/V1State';

export const initialState: TouroperatorVoucherState = {
  loading: false,
};

const actionCreators: ActionHandlers<TouroperatorVoucherState> = {
  [PENDING(PUT_TOUROPERATOR_VOUCHER)]: (state: TouroperatorVoucherState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(PUT_TOUROPERATOR_VOUCHER)]: (
    state: TouroperatorVoucherState,
    action: PutTouroperatorVoucherSuccess
  ) => ({
    ...state,
    loading: false,
    success: true,
    voucher: action.creditCode,
  }),
  [ERROR(PUT_TOUROPERATOR_VOUCHER)]: (
    state: TouroperatorVoucherState,
    action: any
  ) => ({
    ...state,
    loading: false,
    success: false,
    error: action.error,
  }),
  [PURE(RESET_TOUROPERATOR_VOUCHER)]: (
    state: TouroperatorVoucherState,
    action: any
  ) => initialState,
};

// $FlowIgnore
export const touroperatorVoucherReducer: Reducer<TouroperatorVoucherState> =
  // $FlowIgnore
  createReducerUsingActionHandlers<TouroperatorVoucherState>(
    initialState,
    actionCreators
  );

export const isVoucherAvailable: Selector<boolean> = createSelector(
  touroperatorVoucherState,
  (state: TouroperatorVoucherState) => !!state.success
);

export const getVoucher: Selector<string | void> = createSelector(
  touroperatorVoucherState,
  (state: TouroperatorVoucherState) => state.voucher
);
